import { render, staticRenderFns } from "./ProductsCompensationListItem.vue?vue&type=template&id=581818a2&scoped=true&"
import script from "./ProductsCompensationListItem.vue?vue&type=script&lang=js&"
export * from "./ProductsCompensationListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCompensationListItem.vue?vue&type=style&index=0&id=581818a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581818a2",
  null
  
)

export default component.exports